import { twMerge } from 'tailwind-merge';

interface ChartLegendProps {
  text: string;
  squareClassName: string;
}

export const ChartLegend = ({ text, squareClassName }: ChartLegendProps) => {
  return (
    <div className="flex items-center gap-1.5">
      <div className={twMerge('-mt-0.5 w-4 h-4 rounded', squareClassName)} />
      <div className="text-2sm">{text}</div>
    </div>
  );
};
